interface Props {
  tooFewClients: number
}

export default function TooFewClients(props: Props) {

  return (
    <div className="px-8 py-4">
      <div className="mt-4 text-3xl font-medium">Too few clients!</div>
      <div className="mt-4">We only found {props.tooFewClients} clients matching your request.</div>
      <div className="mt-2">We need at least 5 clients to be able to show results.</div>
    </div>
  )
}